<template>
  <div style="width:100%">
    <div class="add_auth_box">
      <div class="hint_txt">
        使用提示：项目管理员可自行添加、删除客服权限。数据归属对应项目人员提成。
      </div>
      <Button type="primary" size="small" style="font-size: 12px" @click="add_user_show = true">
        <Icon type="md-add" /> 添加用户
      </Button>
    </div>


    <div>
      <!-- <Spin size="large" fix v-show="auth_loading"></Spin> -->
      <Table size="small" :columns="columns" style="width:100%" :data="auth_list" :height="160">
        <template #action="{ row }">
          <span class="del_auth" @click="del_auth_click(row)">删除</span>
        </template>
        <template #is_admin="{ row }">
          <div>
            <span>{{ row.is_admin_fmt }}</span>
            <span @click="change_admin(row, 1)" v-if="row.is_admin == 0" class="tiaozheng">升级</span>
            <span @click="change_admin(row, 0)" v-if="row.is_admin == 1" class="tiaozheng2">清除</span>
          </div>
        </template>
        <template #is_data_user="{ row }">
          <div>
            <span @click="update_is_data_user(row)">{{ row.is_data_user_fmt }}</span>
            <span @click="update_is_data_user(row, 1)" class="tiaozheng">变更</span>
          </div>
        </template>

        <template #data_user_proportion="{ row }">
          <div>
            <span @click="update_user_proportion(row)">{{ row.data_user_proportion }}%</span>
            <span @click="update_user_proportion(row, 1)" class="tiaozheng">更新</span>
          </div>
        </template>
      </Table>
    </div>

    <Drawer title="项目客服权限调整" :closable="true" v-model="drawer_show" width="90">
      <div style="padding:10px;color:#fff;background-color: orange;font-size:13px">
        提示：至少有一位数据归属人，数据归属人与提成数据相关，哪个客服的项目就变更为哪个客服。
      </div>
      <div style="text-align: right;padding:10px 0">
        <Button type="primary" size="small" style="font-size: 12px" @click="add_user_show = true">
          <Icon type="md-add" /> 添加用户
        </Button>
      </div>
      <div>
        <Table size="small" :columns="columns" style="width:100%" :data="auth_list">
          <template #action="{ row }">
            <span class="del_auth" @click="del_auth_click(row)">删除</span>
          </template>
          <template #is_admin="{ row }">
            <div>
              <span>{{ row.is_admin_fmt }}</span>
              <span @click="change_admin(row, 1)" v-if="row.is_admin == 0" class="tiaozheng">升级</span>
              <span @click="change_admin(row, 0)" v-if="row.is_admin == 1" class="tiaozheng2">清除</span>
            </div>
          </template>
          <template #is_data_user="{ row }">
            <div>
              <span @click="update_is_data_user(row)">{{ row.is_data_user_fmt }}</span>
              <span @click="update_is_data_user(row, 1)" class="tiaozheng">变更</span>
            </div>
          </template>
          <template #data_user_proportion="{ row }">
            <div>
              <span @click="update_user_proportion(row)">{{ row.data_user_proportion }}%</span>
              <span @click="update_user_proportion(row, 1)" class="tiaozheng">更新</span>
            </div>
          </template>
        </Table>
      </div>
    </Drawer>
    <Modal v-model="add_user_show" title="添加用户" :footer-hide="true">
      <div class="add_user_page">
        <Spin fix v-show="add_user_loading"></Spin>

        <div class="add_user_main">
          <div class="add_user_div">
            <div>选择用户：</div>
            <Select placeholder="请选择或搜索用户" filterable v-model="add_user_data.user_id" style="width: 280px">
              <Option v-for="item in user_list" :value="item.value" :key="item.value">{{ item.label }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="add_user_button">
          <Button type="primary" style="font-size: 12px" @click="add_user_affirm">
            <Icon type="md-add" /> 确认添加
          </Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="update_user_proportion_show" title="数据归属占比" :footer-hide="true" width="400">
      <div class="add_user_page">
        <div style="font-size: 13px;color:#666;margin-bottom:10px;">
          说明：最大100%，如有多个客服，多个客服需共享100%，如合计超出100，会清除其他人的比例！需重新设置。
        </div>
        <div style="margin-top:10px">
          所占比例：
          <InputNumber :max="100" :min="0" :step="0.1" v-model="update_user_proportion_item.data_user_proportion" />%
        </div>
        <div class="add_user_button">
          <Button type="primary" style="font-size: 12px" @click="update_user_proportion_confirm">
            确认更新比例
          </Button>
        </div>
      </div>
    </Modal>



  </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
  name: "project_auth",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      show: false,
      project_id: "",
      user_list: [],
      add_user_show: false,
      add_user_data: {
        user_id: "",
      },
      columns: [],
      auth_list: [],
      auth_loading: false,
      add_user_loading: false,
      drawer_show: false,

      update_user_proportion_show: false,
      update_user_proportion_item: {}
    };
  },
  mounted() { },

  methods: {
    open_drawer() {
      this.drawer_show = true
    },
    update_user_proportion(row) {
      this.update_user_proportion_item = JSON.parse(JSON.stringify(row))
      this.update_user_proportion_show = true

    },

    update_user_proportion_confirm() {
      var that = this;
      var obj = {
        id: this.update_user_proportion_item.id,
        project_id:this.project_id,
        data_user_proportion: this.update_user_proportion_item.data_user_proportion,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/update_data_user_proportion",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_auth_project();
            that.update_user_proportion_show=false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.auth_loading = false;
          
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });

    },
    update_is_data_user(row) {
      console.log(row)
      var that = this;
      var obj = {
        id: row.id,
        is_data_user: row.is_data_user,
      };
      that.auth_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/update_data_user",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_auth_project();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.auth_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });

    },
    del_auth_click(row) {
      var that = this;

      this.$Modal.confirm({
        title: "取消权限",
        content: "<p>正在删除客服权限，要继续吗?" + "</p>",
        onOk: () => {
          that.del_auth(row);
        },
        onCancel: () => { },
      });
    },

    //调整为管理员
    change_admin(row, status) {
      var id = row.id;
      var that = this;
      var obj = {
        id: id,
        status: status,
      };
      that.auth_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/add_project_admin",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_auth_project();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.auth_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    del_auth(row) {
      var id = row.id;
      var that = this;
      var obj = {
        project_id: row.project_id,
        id: id,
      };
      that.auth_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/del_authority",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_auth_project();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.auth_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //项目权限列表
    get_auth_project() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      that.auth_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/auth_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.auth_list = res.data.auth_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.auth_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //确认添加
    add_user_affirm() {
      if (this.add_user_data.user_id == "") {
        this.$Message.error("请选择用户");
        return;
      }
      var that = this;
      this.add_user_loading = true;
      var obj = {
        project_id: this.project_id,
        user_id: this.add_user_data.user_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/add_authority",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_user_show = false;
            that.get_auth_project();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.add_user_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_user_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/authority/user_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(project_id) {
      this.project_id = project_id;
      this.show = true;
      this.get_user_list();
      this.get_auth_project();
    },
  },
};
</script>

<style scoped>
.tiaozheng {
  color: #0466dd;
  margin-left: 3px;
  cursor: pointer;
}

.tiaozheng2 {
  color: #dd1204;
  margin-left: 3px;
  cursor: pointer;
}

.del_auth {
  color: #ee1000;
  cursor: pointer;
}

.hint_txt {
  padding-left: 10px;
  color: #939393;
  font-size: 13px;
  ;
}

.add_auth_box {
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between
}

.add_user_page {
  position: relative;
}

.add_user_main {
  display: flex;
  justify-content: center;
}

.add_user_div {
  display: flex;
  align-items: center;
}

.add_user_button {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
</style>
